import { FEEDBACK_STRUCTURE } from 'utils/constants';
import {
    mapQuizCriteriaByOrder,
    mergeResyncedQuiz,
    reconcileQuestionCriteria,
    remapQuestionCriteria,
    updateQuizQuestion,
} from 'utils/quizDraft';
import { QuizQuestionMode, reconcileQuizFeedbackTemplates, remapQuizFeedbackTemplates } from 'utils/quizRubric';

export const QUIZ_DRAFT_ACTION = Object.freeze({
    HYDRATE: 'hydrate',
    SET_STEP: 'set-step',
    UPDATE_QUIZ: 'update-quiz',
    UPDATE_FORM: 'update-form',
    SET_RUBRIC_TYPE: 'set-rubric-type',
    SAVE_RUBRIC: 'save-rubric',
    DELETE_RUBRIC: 'delete-rubric',
    SYNC_RUBRIC: 'sync-rubric',
    SET_MAP_CRITERIA_BY_ORDER: 'set-map-criteria-by-order',
    UPDATE_QUESTION: 'update-question',
    RESYNC_QUIZ: 'resync-quiz',
    SAVE_FEEDBACK: 'save-feedback',
});

export const quizDraftReducer = (state, action) => {
    switch (action.type) {
        case QUIZ_DRAFT_ACTION.HYDRATE:
            return action.draft;
        case QUIZ_DRAFT_ACTION.SET_STEP:
            return { ...state, step: action.step };
        case QUIZ_DRAFT_ACTION.UPDATE_QUIZ:
            return {
                ...state,
                quiz:
                    typeof action.update === 'function'
                        ? action.update(state.quiz)
                        : { ...state.quiz, ...action.update },
            };
        case QUIZ_DRAFT_ACTION.UPDATE_FORM:
            return {
                ...state,
                form:
                    typeof action.update === 'function'
                        ? action.update(state.form)
                        : { ...state.form, ...action.update },
            };
        case QUIZ_DRAFT_ACTION.SET_RUBRIC_TYPE:
            return {
                ...state,
                form: {
                    ...state.form,
                    rubricType: action.rubricType,
                    questionMode: QuizQuestionMode.INTERDEPENDENT,
                },
            };
        case QUIZ_DRAFT_ACTION.SAVE_RUBRIC:
            return {
                ...state,
                questions: state.form.mapCriteriaByOrder
                    ? mapQuizCriteriaByOrder(state.questions, action.rubric, true)
                    : reconcileQuestionCriteria(state.questions, action.rubric),
                form: {
                    ...state.form,
                    rubric: action.rubric,
                    feedbackSettings: {
                        ...state.form.feedbackSettings,
                        templated: reconcileQuizFeedbackTemplates(state.form.feedbackSettings.templated, action.rubric),
                    },
                },
                rubricNeedsSync: true,
            };
        case QUIZ_DRAFT_ACTION.DELETE_RUBRIC:
            return {
                ...state,
                questions: mapQuizCriteriaByOrder(state.questions, null, false),
                form: {
                    ...state.form,
                    rubric: null,
                    feedbackSettings: {
                        ...state.form.feedbackSettings,
                        structure:
                            state.form.feedbackSettings.structure === FEEDBACK_STRUCTURE.TEMPLATED
                                ? FEEDBACK_STRUCTURE.RUBRIC
                                : state.form.feedbackSettings.structure,
                        templated: null,
                    },
                },
                rubricNeedsSync: false,
            };
        case QUIZ_DRAFT_ACTION.SYNC_RUBRIC:
            return {
                ...state,
                questions: state.form.mapCriteriaByOrder
                    ? mapQuizCriteriaByOrder(state.questions, action.rubric, true)
                    : remapQuestionCriteria(state.questions, state.form.rubric, action.rubric),
                step: 3,
                form: {
                    ...state.form,
                    api_data: action.api_data,
                    rubric: action.rubric,
                    feedbackSettings: {
                        ...state.form.feedbackSettings,
                        templated: remapQuizFeedbackTemplates(
                            state.form.feedbackSettings.templated,
                            state.form.rubric,
                            action.rubric
                        ),
                    },
                },
                rubricNeedsSync: false,
            };
        case QUIZ_DRAFT_ACTION.SET_MAP_CRITERIA_BY_ORDER:
            return {
                ...state,
                questions: mapQuizCriteriaByOrder(state.questions, state.form.rubric, action.checked),
                form: { ...state.form, mapCriteriaByOrder: action.checked },
            };
        case QUIZ_DRAFT_ACTION.UPDATE_QUESTION:
            return {
                ...state,
                questions: updateQuizQuestion(state.questions, action.questionId, action.changes),
            };
        case QUIZ_DRAFT_ACTION.RESYNC_QUIZ:
            return mergeResyncedQuiz(state, action.quiz, action.courseId);
        case QUIZ_DRAFT_ACTION.SAVE_FEEDBACK:
            return {
                ...state,
                form: {
                    ...state.form,
                    feedbackSettings: action.feedbackSettings,
                    feedbackCustomContext: action.feedbackCustomContext,
                },
            };
        default:
            return state;
    }
};
